import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { X } from 'lucide-react';
import { brand } from '../../config/brand';

const navItems = [
  { path: '/workshops', label: 'Our Workshops', id: 'workshops' },
  { path: '/corporate', label: 'Corporate Workshops', id: 'corporate' },
  { path: '/events', label: 'Our Events', id: 'events' },
  { path: '/calendar', label: 'Calendar', id: 'calendar' },
  { path: '/gallery', label: 'Gallery', id: 'gallery' },
  { path: '/contact', label: 'Contact', id: 'contact' },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const navEl = document.getElementById('mainNav');
    const onScroll = () => {
      if (!navEl) return;
      navEl.classList.toggle('scrolled', window.scrollY > 20);
    };
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <>
      <nav id="mainNav" className="fade-in">
        <Link className="nav-logo" to="/" aria-label={`${brand.name} — Home`}>
          <span className="nav-logo-frame">
            <img
              src={brand.logoSrc}
              alt={brand.logoAlt}
              className="nav-logo-image"
              decoding="async"
              data-keep-image="true"
            />
          </span>
          <span className="nav-logo-text">{brand.name}</span>
        </Link>
        <ul className="nav-links">
          {navItems.map((item) => (
            <li key={item.path}>
              <NavLink
                to={item.path}
                id={`nav-${item.id}`}
                className={({ isActive }) => {
                  const workshopsActive = item.path === '/workshops' && location.pathname.startsWith('/workshops');
                  return isActive || workshopsActive ? 'active' : '';
                }}
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
        <div className="nav-right">
          <div className="hamburger" onClick={() => setOpen((v) => !v)} id="hamburger" role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && setOpen((v) => !v)} aria-label="Open menu">
            <span />
            <span />
            <span />
          </div>
        </div>
      </nav>

      <div className={`mobile-menu ${open ? 'open' : ''}`} id="mobileMenu">
        <button className="mobile-close" type="button" onClick={() => setOpen(false)} aria-label="Close menu">
          <X strokeWidth={1.5} />
        </button>
        <Link to="/" onClick={() => setOpen(false)}>
          Home
        </Link>
        {navItems.map((item) => (
          <Link key={item.path} to={item.path} onClick={() => setOpen(false)}>
            {item.label}
          </Link>
        ))}
      </div>
    </>
  );
};

export default Navbar;
